export default __webpack_public_path__ + "static/media/VolvoNovum-Medium.b17b5227.eot";